import styled from 'styled-components';

export const FiltersList = styled.div`
`;

export const TypeName = styled.span`
  font-size: 14px;
  font-weight: 500;
  padding: 2px;
  margin-bottom: 8px;
  color: black;
  border-bottom: 4px solid #172B4D;
`;

export const FilterItem = styled.div`
  color: rgba(0, 0, 0, .9);
  font-size: 12px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 4px 10px 4px 20px;
  cursor: pointer;
  line-height: 16px;
  user-select: none;

  align-items: center;

  &:hover {
    background: #f4f5f7;
  }

  span {
    color: rgba(0, 0, 0, .5);
  }

  &:hover span {
    color: #172B4D;
  }
`;
